export const id = 'lavak-multiplechoice';

import { ItemMode } from '../../../model/interfaces';
import { itemDefinitionFactoryProvider } from '../../factoryProvider';


itemDefinitionFactoryProvider.register({
    id: id,
    uuid: 'a6a55967-eaaf-4009-ab19-68a48a6c0b72',
    widgetNames: {
        modes: new Map<ItemMode, string>([
            ['EDIT', `itemdefinition-${id}-edit`]
        ]),
        fallback: 'itemdefinition-' + id
    },
});
